import { render, staticRenderFns } from "./cabinet-verification.vue?vue&type=template&id=13a49014&scoped=true&"
import script from "./cabinet-verification.vue?vue&type=script&lang=js&"
export * from "./cabinet-verification.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-verification.vue?vue&type=style&index=0&id=13a49014&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a49014",
  null
  
)

export default component.exports